import { relationListApi, relationInfoApi } from '@/api/my/relation'
// initial state
const state = {
  relationList: [],
  relationInfo: {}
}

// getters
const getters = {
  relationList: state => state.relationList
}

// actions
const actions = {
  // 关系人列表
  relationListAction ({ commit }) {
    return new Promise((resolve, reject) => {
      relationListApi().then(response => {
        if (response.status === '2000') {
          commit('setRelationList', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 关系人信息
  relationInfoAction ({ commit }, query) {
    return new Promise((resolve, reject) => {
      relationInfoApi(query).then(response => {
        if (response.status === '2000') {
          commit('setRelationInfo', response.data)
          resolve()
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}

// mutations
const mutations = {
  setRelationList (state, relationList) {
    state.relationList = relationList
  },
  setRelationInfo (state, relationInfo) {
    state.relationInfo = relationInfo
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/my/relation.js